import {absolutePosition, cardStyle} from '@styles/reusable';
import styled from '@emotion/styled';
import {colors} from '@styles/colors';
import {css} from '@emotion/react';
import {AttendanceStatus} from '@models/AttendanceType';


export const PlainStudenCardContainer = styled.div<{ selected: boolean; blurred: boolean; mock?: boolean, backgroundColor?:boolean }>`
  ${cardStyle}
  position:relative;
  display: flex;
  flex-direction: row;
  height: 83px;
  background: ${(props) => (props.mock ? props.theme.colors.mockColor : (props.backgroundColor? '#fff':'var(--backgroundColor)'))};
  z-index: 1;
  transition: background, 0.2s;
  margin-top: 0;
  opacity: ${({ blurred }) => (blurred ? 0.35 : 1)} !important;
  pointer-events: ${({ blurred }) => (blurred ? "none" : "unset")} !important;
  cursor: ${({ blurred }) => (blurred ? 'default' : 'pointer')};
  border-radius: ${(props) => props.theme.pillBorderRadius}px;

  &::before {
    ${absolutePosition}
    content: ' ';
    width: calc(100% + 16px);
    height: calc(100% + 16px);
    left: -8px;
    top: -8px;
    transition: box-shadow 0.2s;
    box-shadow: inset 0px 0px 0px ${({ selected }) => (selected ? (props) => props.theme.selectionBorderSize : 0)}px
      ${(props) => props.theme.colors.selectionBorderColor};
    border-radius: ${(props) => props.theme.pillBorderRadius}px;
    z-index: 1;
    pointer-events: none;
  }
`;

export const StudentImage = styled.div`
  position: relative;
  width: 23%;
  height: 100%;
  overflow: hidden;
  border-top-left-radius: ${(props) => props.theme.pillBorderRadius}px;
  border-bottom-left-radius: ${(props) => props.theme.pillBorderRadius}px;

  img {
    width: 100% !important;
    height: 100% !important;
  }
`;

export const ProfileContainer = styled.section<{ contrast: boolean, attendanceStatus: string, privacyEnabled: boolean }>`
  position: absolute;
  display: grid;
  width: 77%;
  height: 100%;
  left: 23%;
  top: 0;
  padding-left: 12px;
  padding-right: 12px;
  grid-template-columns: ${({ privacyEnabled }) => (!privacyEnabled ? '55fr 45fr' : '1fr')};
  color: ${(props) => (props.contrast? props.theme.colors.mainTextColor: (props.attendanceStatus === AttendanceStatus.Unknown ? props.theme.colors.mainTextColor : props.theme.colors.white))};
`;

export const ProfileSummary = styled.div`
  display: grid;
  align-content: center;
  margin-right: 5px;

  h3 {
    margin-top: 3px;
    margin-bottom: 3px;
    line-height: 1.1;
  }
`;

export const Status = css`
  position: absolute;
  top: 8px;
  left: 8px;
  width: 9px;
  height: 9px;
  z-index: 1;
`;

export const ProfileStatsDivider = styled.div`
  position: absolute;
  top: 20px;
  height: 44px;
  width: 1px;
  background-color: ${colors.gray_20};
`;

export const ProfileStats = styled.div`
  padding-left: 12px;
  position: relative;
  display: grid;
  align-content: center;
`;